
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype3On as ObiMosfetPtype3OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-3-on.js';
 
 
 

 
 export const ObiMosfetPtype3On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-3-on',
   elementClass: ObiMosfetPtype3OnElement,
   events: {
     
   }
  });
 
 